import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@mui/material'
import { cloneDeep, set } from 'lodash'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useUpdateMerchantProfileMutation } from 'src/_api/profileAccountApi'
import { ProfileBankAccountInfoCard } from 'src/_modules/Account/components'
import { MERCHANT_BANK_ACCOUNT_INFO_SCHEMA } from 'src/_modules/Account/ValidationSchemas'
import { runJoiValidate } from 'src/_utils'

export default function BankAccountDialog({
    bankInfo,
    open,
    onClose,
    profileRefetch,
}) {
    const { t } = useTranslation()

    const [bankInformation, setBankInformation] = useState({})

    const handleProfileChange = ({ target: { name, value } }) => {
        setBankInformation(prevState => {
            let clone = cloneDeep(prevState)
            set(clone, name.split('.')[1], value)
            return clone
        })
    }

    useEffect(() => {
        if (open && !!bankInfo) {
            setBankInformation(bankInfo)
        }
    }, [open, bankInfo])

    const [updateMerchantProfile,
        {
            isLoading: updateProfileLoading,
            isSuccess: updateProfileIsSuccess,
            error: updateProfileError,
            reset: updateProfileReset
        }
    ] = useUpdateMerchantProfileMutation()

    //===============Update profile handlers================
    const [validationErrors, setValidationErrors] = useState(null)

    const updateProfileHandler = async (card, payload) => {
        try {
            await updateMerchantProfile(payload).unwrap()
            profileRefetch()
        } catch (error) {
            console.log("Error updating profile:", error);
        }
    }

    const updateProfileBankAccountInfoHandler = async () => {
        try {
            setValidationErrors(null)
            updateProfileReset()

            const errors = runJoiValidate(MERCHANT_BANK_ACCOUNT_INFO_SCHEMA, bankInformation)
            if (!!errors) {
                setValidationErrors(errors)
                return
            }

            await updateProfileHandler("BANK_ACCOUNT_INFO", { bankInformation });
            setTimeout(() => {
                onClose();
            }, 2500);
        } catch (error) {
            console.log("Error updating bank account information:", error);
        }
    }

    useEffect(() => {
        if (!open) {
            setBankInformation({})
            setValidationErrors(null)
            updateProfileReset()
        }
    }, [open]);

    return (
        <Dialog
            open={open}
            onClose={e => e.preventDefault()}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>{t("Edit Bank Account")}</DialogTitle>
            <Divider />
            <DialogContent>
                <ProfileBankAccountInfoCard
                    bankInformation={bankInformation}
                    onChange={handleProfileChange}
                    validationErrors={validationErrors}
                    onUpateProfile={updateProfileBankAccountInfoHandler}
                    loading={updateProfileLoading}
                    isSuccess={updateProfileIsSuccess}
                    error={updateProfileError}
                />
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button
                    onClick={onClose}
                    variant='contained'
                    sx={{ textTransform: 'none' }}
                >
                    {t("Close")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
